export default {
  data: {
    name: null,
    show: false,
    data: {}
  }
};